import { render, staticRenderFns } from "./bindingUserId.vue?vue&type=template&id=0c34237c&scoped=true"
import script from "./bindingUserId.vue?vue&type=script&lang=js"
export * from "./bindingUserId.vue?vue&type=script&lang=js"
import style0 from "./bindingUserId.vue?vue&type=style&index=0&id=0c34237c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34237c",
  null
  
)

export default component.exports